import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { lossy as _lossy, preserveTransparency as _preserveTransparency, progressive as _progressive } from "../../qualifiers/flag";
import { DeliveryAction } from "./DeliveryAction";
import { ProgressiveQualifier } from "../../qualifiers/progressive";
/**
 * @memberOf Actions.Delivery
 * @extends {Actions.Delivery.DeliveryAction}
 * @see Visit {@link Actions.Delivery|Delivery} for an example
 */

var DeliveryFormat = /*#__PURE__*/function (_DeliveryAction) {
  _inherits(DeliveryFormat, _DeliveryAction);

  var _super = _createSuper(DeliveryFormat);

  function DeliveryFormat() {
    _classCallCheck(this, DeliveryFormat);

    return _super.apply(this, arguments);
  }

  _createClass(DeliveryFormat, [{
    key: "lossy",
    value:
    /**
     * @description Uses lossy compression when delivering animated GIF files.
     * @return {this}
     */
    function lossy() {
      this.addFlag(_lossy());
      return this;
    }
    /**
     * @description Uses progressive compression when delivering JPG file format.
     * @return {this}
     */

  }, {
    key: "progressive",
    value: function progressive(mode) {
      if (mode instanceof ProgressiveQualifier) {
        this.addFlag(mode);
      } else {
        this.addFlag(_progressive(mode));
      }

      return this;
    }
    /**
     * @description Ensures that images with a transparency channel are delivered in PNG format.
     */

  }, {
    key: "preserveTransparency",
    value: function preserveTransparency() {
      this.addFlag(_preserveTransparency());
      return this;
    }
  }]);

  return DeliveryFormat;
}(DeliveryAction);

export { DeliveryFormat };